import React from 'react';
import Link from 'shared/components/Link';
import { T, useTranslate } from 'shared/helper/translate';
import { getApiBaseUrl } from 'shared/helper/request';
var LoginDropdown = function LoginDropdown(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'dropdown-menu' : _ref$className,
    displayed = _ref.displayed,
    digitalTranslationsEnabled = _ref.digitalTranslationsEnabled,
    loggedIn = _ref.loggedIn,
    _ref$onLinkClicked = _ref.onLinkClicked,
    onLinkClicked = _ref$onLinkClicked === void 0 ? function () {} : _ref$onLinkClicked,
    siteLanguage = _ref.siteLanguage,
    showCurie = _ref.showCurie;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var params = "?redirect_uri=".concat(window.location.origin, "/login?logout=1");
  return /*#__PURE__*/React.createElement("ul", {
    className: "".concat(className, " ").concat(displayed ? 'show' : '')
  }, !loggedIn ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("li", {
    className: "nav-item"
  }, /*#__PURE__*/React.createElement(Link, {
    onClick: function onClick() {
      return onLinkClicked();
    },
    to: "/".concat(siteLanguage, "/login"),
    className: "welcome nav-link"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Login"
  }))), /*#__PURE__*/React.createElement("li", {
    className: "d-none d-sm-block nav-item"
  }, /*#__PURE__*/React.createElement(Link, {
    onClick: function onClick() {
      return onLinkClicked();
    },
    to: "/".concat(siteLanguage, "/register"),
    className: "welcome nav-link"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Sign Up"
  })))) : null, /*#__PURE__*/React.createElement("li", {
    className: "nav-item"
  }, /*#__PURE__*/React.createElement("a", {
    className: "nav-link",
    "aria-label": t('My Orders'),
    href: "".concat(getApiBaseUrl(), "/").concat(siteLanguage, "/researcher")
  }, /*#__PURE__*/React.createElement(T, {
    source: "My Orders"
  }))), /*#__PURE__*/React.createElement("li", {
    className: "nav-item"
  }, /*#__PURE__*/React.createElement("a", {
    className: "nav-link",
    "aria-label": t('My Invoices'),
    href: "".concat(getApiBaseUrl(), "/").concat(siteLanguage, "/researcher/invoices")
  }, /*#__PURE__*/React.createElement(T, {
    source: "My Invoices"
  }))), /*#__PURE__*/React.createElement("li", {
    className: "nav-item"
  }, /*#__PURE__*/React.createElement("a", {
    className: "nav-link",
    "aria-label": t('My Account'),
    href: "".concat(getApiBaseUrl(), "/").concat(siteLanguage, "/account")
  }, /*#__PURE__*/React.createElement(T, {
    source: "My Account"
  }))), /*#__PURE__*/React.createElement("li", {
    className: "nav-item"
  }, /*#__PURE__*/React.createElement("a", {
    className: "nav-link",
    "aria-label": t('My AJE Rewards'),
    href: "".concat(getApiBaseUrl(), "/").concat(siteLanguage, "/researcher/rewards")
  }, /*#__PURE__*/React.createElement(T, {
    source: "My AJE Rewards"
  }))), showCurie ? null : /*#__PURE__*/React.createElement("li", {
    className: "nav-item"
  }, /*#__PURE__*/React.createElement("a", {
    className: "nav-link",
    "aria-label": t('My Digital Editing'),
    href: "".concat(getApiBaseUrl(), "/researcher/digital-editing")
  }, /*#__PURE__*/React.createElement(T, {
    source: "My Digital Editing"
  }))), digitalTranslationsEnabled && !showCurie ? /*#__PURE__*/React.createElement("li", {
    className: "nav-item"
  }, /*#__PURE__*/React.createElement("a", {
    className: "nav-link",
    "aria-label": t('My Digital Translations'),
    href: "".concat(getApiBaseUrl(), "/researcher/digital-translations")
  }, /*#__PURE__*/React.createElement(T, {
    source: "My Digital Translations"
  }))) : null, /*#__PURE__*/React.createElement("li", {
    className: "nav-item"
  }, /*#__PURE__*/React.createElement("a", {
    className: "nav-link",
    "aria-label": t('My PrePay and Credits'),
    href: "".concat(getApiBaseUrl(), "/").concat(siteLanguage, "/researcher/prepay")
  }, /*#__PURE__*/React.createElement(T, {
    source: "My PrePay and Credits"
  }))), /*#__PURE__*/React.createElement("li", {
    className: "nav-item"
  }, /*#__PURE__*/React.createElement("a", {
    className: "nav-link",
    "aria-label": t('Refer a Colleague'),
    href: "".concat(getApiBaseUrl(), "/").concat(siteLanguage, "/referral-rewards")
  }, /*#__PURE__*/React.createElement(T, {
    source: "Refer a Colleague"
  }))), showCurie ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("li", {
    className: "nav-item"
  }, /*#__PURE__*/React.createElement(Link, {
    className: "nav-link",
    onClick: function onClick() {
      return onLinkClicked();
    },
    to: "/".concat(siteLanguage, "/rubriq/editing")
  }, /*#__PURE__*/React.createElement(T, {
    source: "workspace"
  }))), /*#__PURE__*/React.createElement("li", {
    className: "nav-item"
  }, /*#__PURE__*/React.createElement(Link, {
    className: "nav-link",
    onClick: function onClick() {
      return onLinkClicked();
    },
    to: "/".concat(siteLanguage, "/rubriq/plan")
  }, /*#__PURE__*/React.createElement(T, {
    source: "my-plan"
  })))) : null, loggedIn ? /*#__PURE__*/React.createElement("li", {
    className: "nav-item"
  }, /*#__PURE__*/React.createElement("a", {
    "aria-label": t('Log out'),
    className: "logout-action nav-link",
    href: "".concat(getApiBaseUrl(), "/api/auth/logout").concat(params),
    rel: "logout"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Log out"
  }))) : null);
};
export default LoginDropdown;